// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkList_root__3VNmv"};